<template>
    <h2 class="heading">Deck Document Form</h2>
    <div class="form">
        <el-form :model="deckDoc" label-width="250px" style="width:900px" >
            <el-form-item label="Document type" required>
                <el-select v-model="deckDoc.type" placeholder="Select document type" style="width:220px">
                    <el-option label="Decks" value="Decks"/>
                    <el-option label="Others" value="Others"/>
                </el-select>
                <el-input v-model="type" v-if="deckDoc.type=='Others'" placeholder="Others please specify"
                    style="width:420px; margin-left:10px;" maxlength="50" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Title (English)" required>
                <el-input v-model="deckDoc.title" placeholder="Title (English)" maxlength="250"  show-word-limit="true" />
            </el-form-item>
            <el-form-item label="Title (Other language)">
                <el-input v-model="deckDoc.title2" placeholder="Title (Other language)" maxlength="250"  show-word-limit="true" />
            </el-form-item>
            <el-form-item label="Summary">
                <el-input v-model="deckDoc.summary" type="textarea" maxlength="2000" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Author">
                <el-select v-model="author" placeholder="Select author" style="width:220px;margin-right:10px;" @change="selectAuthor">
                    <el-option v-for="auth in authors" :key="auth" :label="auth.fullname" :value="auth.loginname"/>
                </el-select>
                <template v-if="deckDoc.authors && deckDoc.authors.length">
                    <el-tag v-for="auth in deckDoc.authors.split(',')" :key="auth" @close="removeAuthor(auth)" closable>{{auth}}</el-tag>
                </template>
            </el-form-item>
            <el-form-item label="ETFs">
                <el-select v-model="ETF" placeholder="Select ETF" style="width:220px;margin-right:10px;" @change="selectETF">
                    <el-option v-for="etf in ETFs" :key="etf" :label="etf"  :value="etf"/>
                </el-select>
                <template v-if="deckDoc.ETFs && deckDoc.ETFs.length">
                    <el-tag v-for="etf in deckDoc.ETFs.split(',')" :key="etf" @close="removeETF(etf)" closable>{{etf}}</el-tag>
                </template>
            </el-form-item>
            <el-form-item label="Document files">
                <div v-if="files.indexOf(':') > -1" style="display:block;">
                    <template v-for="item in files.split(';')" :key="item">
                        <el-tag v-if="item.length" @close="removeFile(item)" closable>
                            <a href="" @click.prevent="global.down(item.split(':')[1], item.split(':')[0])">{{item.split(':')[0]}}</a>
                        </el-tag>
                    </template>
                </div>
                <el-upload :action="global.upload_path" multiple :on-success="uploaded"  :data="{type:'deck'}" :show-file-list="false" >
                    <el-button type="primary" plain>Browse</el-button>
                </el-upload>
            </el-form-item>

            <el-form-item label="Compliance's attachments">
                <div v-if="deckDoc.reviewFiles.indexOf(':') > -1" style="display:inline-block;">
                    <el-tag v-for="item in deckDoc.reviewFiles.split(';')" :key="item">
                        <a v-if="item.length" href="" @click.prevent="global.down(item.split(':')[1], item.split(':')[0])">{{item.split(':')[0]}}</a>
                    </el-tag>
                </div>
            </el-form-item>

            <el-form-item label="Publish date" required>
                <el-date-picker v-model="deckDoc.publishDate" type="date" placeholder="Publish date" value-format="YYYY-MM-DD"/>
            </el-form-item>
            <el-form-item label="Memo">
                <el-input v-model="deckDoc.memo" type="textarea" maxlength="500" show-word-limit="true"/>
            </el-form-item>

            <el-form-item label="">
                <el-button type="primary" @click="submitDeck">Submit</el-button>
                <span class="errMsg" v-if="errMsg != ''">{{errMsg}}</span>
                <span v-if="loading" style="display:inline-block; margin-left:20px; vertical-align:middle;">
                    <img src="@/assets/loading.gif" style="height:24px;"/>
                </span>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
const authors = [{loginname:"Rebecca", fullname: "Rebecca Chua"}, 
                 {loginname:"David", fullname: "David Lai"}, 
                 {loginname:"Laura", fullname: "Laura Lui"}, 
                 {loginname:"Alex", fullname: "Alex Chu"}, 
                 {loginname:"Larry", fullname: "Larry Kwok"}, 
                 {loginname:"Simon", fullname: "Simon Lee"}, 
                 {loginname:"Gloria", fullname: "Gloria Liu"}, 
                 {loginname:"Michael", fullname: "Michael Ng"},
                 {loginname:"Jinny", fullname: "Jinny Kim"}, 
                 {loginname:"Jess", fullname: "Jess Liu"}];

const ETFs = ["ALL", "2803", "3173", "3181", "2810", "2804", "3077", "9078", "2817", "9177", "3001", "3151", "3411", "3453", "9159", "3478"];
import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'

export default {
    data() {
        return {
            authors, ETFs,
            speaker: '', type: '', attendeeRole: '', internalLead: '',
            deckDoc: {
                id: null,
                type: '',
                title: '',
                title2: '',
                summary: '',
                authors: '',
                etfs: '',
                ETFs: '',
                files: '',
                reviewFiles: '',
                publishDate: '',
                memo: '',
            },
            ETF: null,
            author: '',
            loading: false,
            files: '',
            errMsg: '',
            global,
        }
    },
    async mounted() {
        this.global.index = "deck";
        let code = this.$route.query ? this.$route.query.code : null;
        if (code) {
            let result = await AXIOS("/deck/getDeckDocument", {code: code});
            if (result.success) {
                this.deckDoc = result.data;
                if (this.deckDoc.files.indexOf(":")>-1)
                    this.files = this.deckDoc.files;
                if (this.deckDoc.type != "Decks") {
                    this.type = this.deckDoc.type;
                    this.deckDoc.type = "Others";
                }
                this.deckDoc.ETFs = this.deckDoc.etfs;
            } else {
                this.errMsg = result.errMsg;
            }
        }
    },
    methods: {
        uploaded(response) {
            let files = response.length ? response[0].name + ":" + response[0].url : '';
            if (files != '' && this.files.indexOf(files) == -1) {
                this.files = (this.files == '') ? files : this.files + ";" + files;
            }
        },
        removeFile(item) {
            this.files = this.files + ";"
            this.files = this.files.replace(item+";", "");
            if (this.files.endsWith(";"))
                this.files = this.files.substring(0, this.files.length-1);
        },
        selectAuthor() {
            if (this.deckDoc.authors.indexOf(this.author) == -1) {
                this.deckDoc.authors = (this.deckDoc.authors == '') ? this.author : this.deckDoc.authors + "," + this.author;
            }
        },
        selectETF() {
            if (this.ETF == 'ALL') {
                this.deckDoc.ETFs = this.ETF;
            } else if (this.deckDoc.ETFs.indexOf(this.ETF) == -1) {
                if (this.deckDoc.ETFs == "ALL")
                    this.deckDoc.ETFs = "";
                this.deckDoc.ETFs = this.deckDoc.ETFs == '' ? this.ETF : this.deckDoc.ETFs + "," + this.ETF;
            }
        },
        removeAuthor(item) {
            this.deckDoc.authors += ","
            this.deckDoc.authors = this.deckDoc.authors.replace(item+",", "");
            if (this.deckDoc.authors.endsWith(","))
                this.deckDoc.authors = this.deckDoc.authors.substring(0, this.deckDoc.authors.length-1);
        },
        removeETF(item) {
            this.deckDoc.ETFs += ","
            this.deckDoc.ETFs = this.deckDoc.ETFs.replace(item+",", "");
            if (this.deckDoc.ETFs.endsWith(","))
                this.deckDoc.ETFs = this.deckDoc.ETFs.substring(0, this.deckDoc.ETFs.length-1);
        },
        async submitDeck() {
            this.errMsg = "";
            if (this.deckDoc.type == "") {
                this.errMsg = "[Document type] is required"; return;
            }
            if (this.deckDoc.title == "") {
                this.errMsg = "[Title (English)] is required"; return;
            }
            if (this.files == "") {
                this.errMsg = "[Document files] is required"; return;
            }
            if (this.deckDoc.publishDate == "") {
                this.errMsg = "[Publish date] is required"; return;
            }
            if (this.deckDoc.type == "Others") this.deckDoc.type = this.type;
            this.deckDoc.files = this.files;
            this.deckDoc.createTime = null;
            this.deckDoc.lastupdate = null;
            
            if (this.loading) return; // avoid repeat submit
            this.loading = true;
            let result = await AXIOS("/deck/saveDeckDocument", this.deckDoc);
            if (result.success) {
                this.$router.push("/deck/myDeckDocuments");
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        }
    }
}
</script>

<style scoped>
    .heading {
        width:900px;
    }
    .errMsg {
        padding-left:10px;
    }
    .el-tag a {cursor: pointer; }
</style>